<template>
    <a-button type="primary" @click="openModal">
        Create funnel
    </a-button>

    <a-modal
        v-model:open="showModal"
        title="Create Funnel"
        :maskClosable="false"
        @cancel="closeModal"
        @ok="createFunnelHandler"
        :confirmLoading="loading"
    >
        <a-form
            layout="vertical"
            class="funnel-form"
        >
            <a-form-item label="Funnel Name">
                <a-input
                    v-model:value="funnelName"
                    :maxLength="255"
                    placeholder="Input a funnel name"
                />
                <div class="text-xs text-right text-gray-500">
                    {{ funnelName.length }}/255
                </div>
            </a-form-item>

            <a-form-item label="Funnel Template Type">
                <a-select
                    v-model:value="funnelTemplateType"
                    :options="funnelTemplateOptions"
                    class="w-full"
                />
            </a-form-item>

            <a-form-item>
                <a-checkbox v-model:checked="newPostupsellFlow">
                    New postupsell flow
                </a-checkbox>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { createFunnel, type CreateFunnel } from '@/api/funnels'
import { useFunnelStore } from '@/store/modules/funnel'
import { message } from 'ant-design-vue'

const showModal = ref(false)
const loading = ref(false)
const funnelName = ref('')
const funnelTemplateType = ref('1 Page Checkout')
const newPostupsellFlow = ref(false)

const funnelTemplateOptions = [
    { value: '1 Page Checkout', label: '1 Page Checkout' },
    { value: '3 Page Checkout', label: '3 Page Checkout' },
    { value: 'Direct Checkout with PayPal', label: 'Direct Checkout with PayPal' }
]

const openModal = () => {
    showModal.value = true
}

const closeModal = () => {
    showModal.value = false
    // Reset form fields
    funnelName.value = ''
    funnelTemplateType.value = '1 Page Checkout'
    newPostupsellFlow.value = false
    loading.value = false
}

const createFunnelHandler = async () => {
    if (!funnelName.value.trim()) {
        message.error('Please enter a funnel name')
        return
    }

    loading.value = true
    const apiTemplateType: 'one_page_checkout' | 'three_pages_checkout' | 'paypal_with_upsell' =
        (() => {
            switch (funnelTemplateType.value) {
                case '1 Page Checkout':
                    return 'one_page_checkout'
                case '3 Page Checkout':
                    return 'three_pages_checkout'
                case 'Direct Checkout with PayPal':
                    return 'paypal_with_upsell'
                default:
                    return 'one_page_checkout'
            }
        })()

    const param: CreateFunnel = {
        name: funnelName.value,
        templateType: apiTemplateType,
        postupsellFunnelType: 'webc',
        newPostupsellFlow: newPostupsellFlow.value,
    }
    try {
        const funnelStore = useFunnelStore()
        await createFunnel(param)
        message.success('Funnel created successfully')
        // Refresh funnel list
        await funnelStore.updateSaveState(false)
        await funnelStore.updateSaveState(true)
    } catch (error) {
        console.error('Error creating funnel:', error)
        message.error('Failed to create funnel')
    } finally {
        closeModal()
    }
}
</script>

<style scoped>
.funnel-form {
    padding: 8px 0;
}
</style>
